// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-item-box .el-input__inner {\n  font-size: 12px;\n  padding: 0 8px;\n}\n", ""]);
// Exports
module.exports = exports;
